// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/person.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { PendingPayment } from "./tax";
import { OasResidency } from "./tax";
import { TaxYearToDate } from "./tax";
import { RegisteredRoom } from "./tax";
import { T4Slip } from "./tax";
import { CraRoomStatement } from "./tax";
import { NoticeOfAssessment } from "./tax";
import { DCPensionAccount } from "./accounts";
import { RRIFAccount } from "./accounts";
import { FHSAAccount } from "./accounts";
import { RESPAccount } from "./accounts";
import { NonRegisteredInvestmentAccount } from "./accounts";
import { ChequingAccount } from "./accounts";
import { CreditCard } from "./debts";
import { TFSAAccount } from "./accounts";
import { RRSPAccount } from "./accounts";
import { DateSchedule } from "../../optimizer/v1/date_schedule";
import { Date } from "./date";
/**
 * Retirement as the user described it. With RETIREMENT_METHOD_SPENDING (the default) the engine
 * works the target out from spending; with RETIREMENT_METHOD_TARGET it uses these fields.
 *
 * @generated from protobuf message core.v1.RetirementGoal
 */
export interface RetirementGoal {
    /**
     * @generated from protobuf field: optional int32 retirement_age = 1;
     */
    retirementAge?: number;
    /**
     * @generated from protobuf field: optional double retirement_annual = 2;
     */
    retirementAnnual?: number; // target annual spending in retirement, today's dollars
    /**
     * @generated from protobuf field: optional double income_replacement_percent = 3;
     */
    incomeReplacementPercent?: number; // share of today's gross income (prototype "pick" mode)
}
/**
 * @generated from protobuf message core.v1.DefinedBenefitDetails
 */
export interface DefinedBenefitDetails {
    /**
     * Accrual rate for salary portion below YMPE (e.g., 1.6 for 1.6% per year of service)
     *
     * @generated from protobuf field: optional double below_ympe_accrual_rate = 1;
     */
    belowYmpeAccrualRate?: number;
    /**
     * Accrual rate for salary portion above YMPE (e.g., 2.0 for 2% per year of service)
     *
     * @generated from protobuf field: optional double above_ympe_accrual_rate = 2;
     */
    aboveYmpeAccrualRate?: number;
    /**
     * Number of years to average for final earnings calculation
     *
     * @generated from protobuf field: optional int32 averaging_years = 3;
     */
    averagingYears?: number;
    /**
     * Maximum benefit percentage cap (e.g., 100 for 100% of final salary)
     *
     * @generated from protobuf field: optional double max_benefit_percentage = 4;
     */
    maxBenefitPercentage?: number;
    /**
     * Maximum annual earnings considered for pension calculation (0 or unset = no cap)
     *
     * @generated from protobuf field: optional double max_pensionable_earnings = 5;
     */
    maxPensionableEarnings?: number;
    /**
     * Reserved for future use, currently ignored
     *
     * @generated from protobuf field: optional int32 max_payout_years = 6;
     */
    maxPayoutYears?: number;
    /**
     * @generated from protobuf field: optional double credited_service_years = 7;
     */
    creditedServiceYears?: number;
    /**
     * @generated from protobuf field: optional int32 earliest_unreduced_age = 8;
     */
    earliestUnreducedAge?: number;
    /**
     * @generated from protobuf field: optional double indexing_percent = 9;
     */
    indexingPercent?: number;
}
/**
 * @generated from protobuf message core.v1.DefinedContributionDetails
 */
export interface DefinedContributionDetails {
    /**
     * @generated from protobuf field: optional double employee_contribution_rate = 1;
     */
    employeeContributionRate?: number;
    /**
     * @generated from protobuf field: optional double fixed_employer_contribution_rate = 2;
     */
    fixedEmployerContributionRate?: number;
    /**
     * @generated from protobuf field: optional double matched_employer_contribution_rate = 7;
     */
    matchedEmployerContributionRate?: number;
    /**
     * @generated from protobuf field: optional double above_ympe_employee_contribution_rate = 8;
     */
    aboveYmpeEmployeeContributionRate?: number;
    /**
     * @generated from protobuf field: optional double above_ympe_fixed_employer_contribution_rate = 9;
     */
    aboveYmpeFixedEmployerContributionRate?: number;
    /**
     * @generated from protobuf field: optional double above_ympe_matched_employer_contribution_rate = 10;
     */
    aboveYmpeMatchedEmployerContributionRate?: number;
    /**
     * @generated from protobuf field: optional double current_balance = 3;
     */
    currentBalance?: number;
    /**
     * @generated from protobuf field: optional double total_contributions = 4;
     */
    totalContributions?: number;
}
/**
 * @generated from protobuf message core.v1.Pension
 */
export interface Pension {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: core.v1.PensionType pension_type = 3;
     */
    pensionType: PensionType;
    /**
     * @generated from protobuf field: optional core.v1.DefinedBenefitDetails db_details = 4;
     */
    dbDetails?: DefinedBenefitDetails;
    /**
     * @generated from protobuf field: optional core.v1.DefinedContributionDetails dc_details = 5;
     */
    dcDetails?: DefinedContributionDetails;
}
/**
 * Current saving habits. Read only by the current-trajectory run (item J §4).
 *
 * @generated from protobuf message core.v1.Contribution
 */
export interface Contribution {
    /**
     * @generated from protobuf field: optional double rrsp_contribution = 1;
     */
    rrspContribution?: number;
    /**
     * @generated from protobuf field: optional double tfsa_contribution = 2;
     */
    tfsaContribution?: number;
    /**
     * @generated from protobuf field: optional double other_contribution = 3;
     */
    otherContribution?: number;
    /**
     * @generated from protobuf field: optional double fhsa_contribution = 4;
     */
    fhsaContribution?: number;
}
/**
 * @generated from protobuf message core.v1.GroupRRSPPlan
 */
export interface GroupRRSPPlan {
    /**
     * @generated from protobuf field: double employer_matching_rate = 1;
     */
    employerMatchingRate: number; // 1.0 = 100% match
    /**
     * @generated from protobuf field: double employer_match_cap_rate = 2;
     */
    employerMatchCapRate: number; // 0.05 = 5% of gross pay
    /**
     * @generated from protobuf field: optional string group_rrsp_uuid = 3;
     */
    groupRrspUuid?: string; // the group RRSP payroll pays into; unset = the engine opens one
    /**
     * @generated from protobuf field: double employee_contribution_rate = 4;
     */
    employeeContributionRate: number; // what payroll puts in now, 0.02 = 2% of gross pay; 0 = nothing
}
/**
 * Employment-type income (taxed as employment income, with CPP/EI).
 *
 * @generated from protobuf message core.v1.Job
 */
export interface Job {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string title = 2;
     */
    title: string;
    /**
     * @generated from protobuf field: double pre_tax_annual_income = 3;
     */
    preTaxAnnualIncome: number;
    /**
     * @generated from protobuf field: core.v1.Date end_date = 4;
     */
    endDate?: Date;
    /**
     * @generated from protobuf field: string employer = 5;
     */
    employer: string;
    /**
     * @generated from protobuf field: core.v1.Date last_known_payment_date = 7;
     */
    lastKnownPaymentDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date start_date = 8;
     */
    startDate?: Date;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule payment_schedule = 9;
     */
    paymentSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: optional string associated_pension_uuid = 10;
     */
    associatedPensionUuid?: string;
    /**
     * @generated from protobuf field: core.v1.IncomeKind kind = 11;
     */
    kind: IncomeKind; // SALARY, HOURLY, SELF_EMPLOYED, COMMISSION or BONUS
    /**
     * @generated from protobuf field: string occupation = 12;
     */
    occupation: string;
    /**
     * @generated from protobuf field: optional core.v1.GroupRRSPPlan group_rrsp_plan = 13;
     */
    groupRrspPlan?: GroupRRSPPlan;
}
/**
 * Income that isn't employment income.
 *
 * @generated from protobuf message core.v1.UntaxedIncome
 */
export interface UntaxedIncome {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: double amount_per_period = 3;
     */
    amountPerPeriod: number;
    /**
     * @generated from protobuf field: core.v1.Date last_known_payment_date = 5;
     */
    lastKnownPaymentDate?: Date;
    /**
     * @generated from protobuf field: optional bool is_recurring = 6;
     */
    isRecurring?: boolean;
    /**
     * @generated from protobuf field: core.v1.Date end_date = 7;
     */
    endDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date start_date = 8;
     */
    startDate?: Date;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule date_schedule = 9;
     */
    dateSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: core.v1.IncomeKind kind = 10;
     */
    kind: IncomeKind;
    /**
     * @generated from protobuf field: bool taxable = 11;
     */
    taxable: boolean; // false for e.g. child support received; true for rental income
}
/**
 * @generated from protobuf message core.v1.Person
 */
export interface Person {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string given_name = 2;
     */
    givenName: string;
    /**
     * @generated from protobuf field: string family_name = 3;
     */
    familyName: string;
    /**
     * @generated from protobuf field: core.v1.Date dob = 4;
     */
    dob?: Date;
    /**
     * @generated from protobuf field: core.v1.RetirementGoal retirement_goal = 5;
     */
    retirementGoal?: RetirementGoal;
    /**
     * @generated from protobuf field: repeated core.v1.Pension pensions = 6;
     */
    pensions: Pension[];
    /**
     * @generated from protobuf field: repeated core.v1.RRSPAccount rrsp_accounts = 7;
     */
    rrspAccounts: RRSPAccount[];
    /**
     * @generated from protobuf field: repeated core.v1.TFSAAccount tfsa_accounts = 8;
     */
    tfsaAccounts: TFSAAccount[];
    /**
     * @generated from protobuf field: core.v1.Contribution contribution = 9;
     */
    contribution?: Contribution;
    /**
     * @generated from protobuf field: repeated core.v1.Job jobs = 10;
     */
    jobs: Job[];
    /**
     * @generated from protobuf field: repeated core.v1.CreditCard credit_cards = 11;
     */
    creditCards: CreditCard[];
    /**
     * @generated from protobuf field: repeated core.v1.ChequingAccount chequing_accounts = 12;
     */
    chequingAccounts: ChequingAccount[];
    /**
     * @generated from protobuf field: repeated core.v1.NonRegisteredInvestmentAccount trading_accounts = 13;
     */
    tradingAccounts: NonRegisteredInvestmentAccount[];
    /**
     * @generated from protobuf field: repeated core.v1.RESPAccount resp_accounts = 14;
     */
    respAccounts: RESPAccount[];
    /**
     * @generated from protobuf field: repeated core.v1.UntaxedIncome untaxed_incomes = 15;
     */
    untaxedIncomes: UntaxedIncome[];
    /**
     * @generated from protobuf field: bool is_first_time_home_buyer = 16;
     */
    isFirstTimeHomeBuyer: boolean;
    /**
     * @generated from protobuf field: repeated core.v1.FHSAAccount fhsa_accounts = 17;
     */
    fhsaAccounts: FHSAAccount[];
    /**
     * @generated from protobuf field: repeated core.v1.RRIFAccount rrif_accounts = 18;
     */
    rrifAccounts: RRIFAccount[];
    /**
     * @generated from protobuf field: repeated core.v1.DCPensionAccount dc_pension_accounts = 19;
     */
    dcPensionAccounts: DCPensionAccount[];
    /**
     * Tax documents and the facts behind the engine's tax state (docs/design/DEVIATIONS.md).
     *
     * @generated from protobuf field: repeated core.v1.NoticeOfAssessment notices_of_assessment = 20;
     */
    noticesOfAssessment: NoticeOfAssessment[];
    /**
     * @generated from protobuf field: repeated core.v1.CraRoomStatement cra_room_statements = 21;
     */
    craRoomStatements: CraRoomStatement[];
    /**
     * @generated from protobuf field: repeated core.v1.T4Slip t4_slips = 22;
     */
    t4Slips: T4Slip[];
    /**
     * @generated from protobuf field: core.v1.RegisteredRoom registered_room = 23;
     */
    registeredRoom?: RegisteredRoom;
    /**
     * @generated from protobuf field: core.v1.TaxYearToDate tax_year_to_date = 24;
     */
    taxYearToDate?: TaxYearToDate;
    /**
     * @generated from protobuf field: core.v1.OasResidency oas_residency = 25;
     */
    oasResidency?: OasResidency;
    /**
     * @generated from protobuf field: repeated core.v1.PendingPayment pending_payments = 26;
     */
    pendingPayments: PendingPayment[];
}
/**
 * @generated from protobuf enum core.v1.PensionType
 */
export enum PensionType {
    /**
     * @generated from protobuf enum value: PENSION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PENSION_TYPE_DEFINED_BENEFIT = 1;
     */
    DEFINED_BENEFIT = 1,
    /**
     * @generated from protobuf enum value: PENSION_TYPE_DEFINED_CONTRIBUTION = 2;
     */
    DEFINED_CONTRIBUTION = 2,
    /**
     * @generated from protobuf enum value: PENSION_TYPE_NO_PENSION = 3;
     */
    NO_PENSION = 3
}
/**
 * @generated from protobuf enum core.v1.IncomeKind
 */
export enum IncomeKind {
    /**
     * @generated from protobuf enum value: INCOME_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INCOME_KIND_SALARY = 1;
     */
    SALARY = 1,
    /**
     * @generated from protobuf enum value: INCOME_KIND_HOURLY = 2;
     */
    HOURLY = 2,
    /**
     * @generated from protobuf enum value: INCOME_KIND_SELF_EMPLOYED = 3;
     */
    SELF_EMPLOYED = 3,
    /**
     * @generated from protobuf enum value: INCOME_KIND_COMMISSION = 4;
     */
    COMMISSION = 4,
    /**
     * @generated from protobuf enum value: INCOME_KIND_BONUS = 5;
     */
    BONUS = 5,
    /**
     * @generated from protobuf enum value: INCOME_KIND_RENTAL = 6;
     */
    RENTAL = 6,
    /**
     * @generated from protobuf enum value: INCOME_KIND_INVESTMENT = 7;
     */
    INVESTMENT = 7,
    /**
     * @generated from protobuf enum value: INCOME_KIND_PENSION = 8;
     */
    PENSION = 8,
    /**
     * @generated from protobuf enum value: INCOME_KIND_GOVERNMENT_BENEFITS = 9;
     */
    GOVERNMENT_BENEFITS = 9,
    /**
     * @generated from protobuf enum value: INCOME_KIND_FAMILY_SUPPORT = 10;
     */
    FAMILY_SUPPORT = 10,
    /**
     * @generated from protobuf enum value: INCOME_KIND_OTHER = 11;
     */
    OTHER = 11
}
// @generated message type with reflection information, may provide speed optimized methods
class RetirementGoal$Type extends MessageType<RetirementGoal> {
    constructor() {
        super("core.v1.RetirementGoal", [
            { no: 1, name: "retirement_age", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "retirement_annual", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "income_replacement_percent", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RetirementGoal
 */
export const RetirementGoal = new RetirementGoal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DefinedBenefitDetails$Type extends MessageType<DefinedBenefitDetails> {
    constructor() {
        super("core.v1.DefinedBenefitDetails", [
            { no: 1, name: "below_ympe_accrual_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "above_ympe_accrual_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "averaging_years", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "max_benefit_percentage", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "max_pensionable_earnings", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "max_payout_years", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "credited_service_years", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "earliest_unreduced_age", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "indexing_percent", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.DefinedBenefitDetails
 */
export const DefinedBenefitDetails = new DefinedBenefitDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DefinedContributionDetails$Type extends MessageType<DefinedContributionDetails> {
    constructor() {
        super("core.v1.DefinedContributionDetails", [
            { no: 1, name: "employee_contribution_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "fixed_employer_contribution_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "matched_employer_contribution_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "above_ympe_employee_contribution_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "above_ympe_fixed_employer_contribution_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "above_ympe_matched_employer_contribution_rate", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "current_balance", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "total_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.DefinedContributionDetails
 */
export const DefinedContributionDetails = new DefinedContributionDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pension$Type extends MessageType<Pension> {
    constructor() {
        super("core.v1.Pension", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pension_type", kind: "enum", T: () => ["core.v1.PensionType", PensionType, "PENSION_TYPE_"] },
            { no: 4, name: "db_details", kind: "message", T: () => DefinedBenefitDetails },
            { no: 5, name: "dc_details", kind: "message", T: () => DefinedContributionDetails }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Pension
 */
export const Pension = new Pension$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Contribution$Type extends MessageType<Contribution> {
    constructor() {
        super("core.v1.Contribution", [
            { no: 1, name: "rrsp_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "tfsa_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "other_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "fhsa_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Contribution
 */
export const Contribution = new Contribution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GroupRRSPPlan$Type extends MessageType<GroupRRSPPlan> {
    constructor() {
        super("core.v1.GroupRRSPPlan", [
            { no: 1, name: "employer_matching_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "employer_match_cap_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "group_rrsp_uuid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "employee_contribution_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.GroupRRSPPlan
 */
export const GroupRRSPPlan = new GroupRRSPPlan$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Job$Type extends MessageType<Job> {
    constructor() {
        super("core.v1.Job", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pre_tax_annual_income", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "end_date", kind: "message", T: () => Date },
            { no: 5, name: "employer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "last_known_payment_date", kind: "message", T: () => Date },
            { no: 8, name: "start_date", kind: "message", T: () => Date },
            { no: 9, name: "payment_schedule", kind: "message", T: () => DateSchedule },
            { no: 10, name: "associated_pension_uuid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "kind", kind: "enum", T: () => ["core.v1.IncomeKind", IncomeKind, "INCOME_KIND_"] },
            { no: 12, name: "occupation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "group_rrsp_plan", kind: "message", T: () => GroupRRSPPlan }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Job
 */
export const Job = new Job$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UntaxedIncome$Type extends MessageType<UntaxedIncome> {
    constructor() {
        super("core.v1.UntaxedIncome", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount_per_period", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "last_known_payment_date", kind: "message", T: () => Date },
            { no: 6, name: "is_recurring", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "end_date", kind: "message", T: () => Date },
            { no: 8, name: "start_date", kind: "message", T: () => Date },
            { no: 9, name: "date_schedule", kind: "message", T: () => DateSchedule },
            { no: 10, name: "kind", kind: "enum", T: () => ["core.v1.IncomeKind", IncomeKind, "INCOME_KIND_"] },
            { no: 11, name: "taxable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.UntaxedIncome
 */
export const UntaxedIncome = new UntaxedIncome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Person$Type extends MessageType<Person> {
    constructor() {
        super("core.v1.Person", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "given_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dob", kind: "message", T: () => Date },
            { no: 5, name: "retirement_goal", kind: "message", T: () => RetirementGoal },
            { no: 6, name: "pensions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Pension },
            { no: 7, name: "rrsp_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => RRSPAccount },
            { no: 8, name: "tfsa_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TFSAAccount },
            { no: 9, name: "contribution", kind: "message", T: () => Contribution },
            { no: 10, name: "jobs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Job },
            { no: 11, name: "credit_cards", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CreditCard },
            { no: 12, name: "chequing_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ChequingAccount },
            { no: 13, name: "trading_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => NonRegisteredInvestmentAccount },
            { no: 14, name: "resp_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => RESPAccount },
            { no: 15, name: "untaxed_incomes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UntaxedIncome },
            { no: 16, name: "is_first_time_home_buyer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "fhsa_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FHSAAccount },
            { no: 18, name: "rrif_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => RRIFAccount },
            { no: 19, name: "dc_pension_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DCPensionAccount },
            { no: 20, name: "notices_of_assessment", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => NoticeOfAssessment },
            { no: 21, name: "cra_room_statements", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CraRoomStatement },
            { no: 22, name: "t4_slips", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => T4Slip },
            { no: 23, name: "registered_room", kind: "message", T: () => RegisteredRoom },
            { no: 24, name: "tax_year_to_date", kind: "message", T: () => TaxYearToDate },
            { no: 25, name: "oas_residency", kind: "message", T: () => OasResidency },
            { no: 26, name: "pending_payments", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PendingPayment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Person
 */
export const Person = new Person$Type();
